import React from 'react';
import {
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Area,
	AreaChart
} from 'recharts';
import { toPercent } from '../../../util/databaseFunctions';

export default function ParticipationChart({
	participationData,
	colors,
	type
}) {
	return (
		<AreaChart
			className="areaChartRechart"
			width={600}
			height={400}
			data={participationData}
			margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
			stackOffset="expand"
		>
			<XAxis dataKey="date" />
			<YAxis tickFormatter={toPercent} />
			<CartesianGrid strokeDasharray="3 3" />
			<Tooltip />
			<Area
				type="monotone"
				stackId="1"
				dataKey={`Went to a "${type}" enrichment at least once`}
				stroke="black"
				fill={colors[6]}
			/>
			<Area
				type="monotone"
				stackId="1"
				dataKey={`Never went to "${type}" enrichment at all`}
				stroke="black"
				fill={colors[2]}
			/>
		</AreaChart>
	);
}
